import { ClassConstructor, classToPlain, plainToClass } from 'class-transformer';
import Lockr from 'lockr';

import { Persistence } from './Persistence';

// you can do this in your project root...
// Lockr.prefix = ConfigFactory.get().sessionStorage.prefix;

class SessionPersistence<T> implements Persistence<T> {
  readonly type: ClassConstructor<T>;

  private key: string;

  constructor(param?: ClassConstructor<T> | string) {
    if (param) {
      if (typeof param === 'string') {
        this.key = param;
      } else {
        this.type = param;
      }
    }
  }

  useKey(key: string): void {
    this.key = key;
  }

  exists(): boolean {
    return Lockr.keys().includes(this.key);
  }

  get(): T {
    if (this.type) {
      return plainToClass(this.type, Lockr.get<T>(this.key) || {});
    }
    return Lockr.get<T>(this.key);
  }

  set(instance: T): void {
    if (this.type) {
      Lockr.set(this.key, classToPlain<T>(instance));
    } else {
      Lockr.set(this.key, instance);
    }
  }

  clear(): void {
    Lockr.rm(this.key);
  }
}

export default SessionPersistence;
